<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Level</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="level.id === null">New</span>
              <span v-else>
                {{ level.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="level.name" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
              <div class="col-sm-9">
                <select v-model="level.promo_id" class="form-control">
                  <option v-for="p in promoList" :key="p.id" :value="p.id">{{ p.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateLevel" class="btn btn-sm btn-primary pull-right" v-show="level.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createLevel" class="btn btn-sm btn-primary pull-right" v-show="level.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ level }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { levelUrl, getHeader } from '../../config'

export default {
  name: 'LevelForm',
  props: ['level'],
  computed: {
    ...mapState({
      promoList: state => state.promos.promoList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateLevel () {
      axios.put(levelUrl + '/' + this.level.id, this.level, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Level', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createLevel () {
      axios.post(levelUrl, this.level, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
